import { FreeTextQuestionFields } from "../components/tools/FreeTextQuestionFields";
import { MultipleChoiceQuestionFields } from "../components/tools/MultipleChoiceQuestionFields";
import { YesNoQuestionFields } from "../components/tools/YesNoQuestionFields";

export const MAXIMUM_QUESTIONS = 20;
export const MAXIMUM_QUESTION_CHOICES = 15;
export const EMPTY_CHOICE = { label: "" };
export const QUESTION_TEXT_MAX_CHARACTERS = 500;

export const QUESTION_TYPE = {
  FREE_TEXT: "free_text",
  MULTIPLE_CHOICE: "multiple_choice",
  YES_NO: "yes_no",
} as const;

export type QuestionType = (typeof QUESTION_TYPE)[keyof typeof QUESTION_TYPE];

export const QUESTION_CHOICE_SELECTION_METHOD = {
  SINGLE: "single",
  MULTIPLE: "multiple",
} as const;

export type QuestionChoiceSelectionMethod =
  (typeof QUESTION_CHOICE_SELECTION_METHOD)[keyof typeof QUESTION_CHOICE_SELECTION_METHOD];

export const QUESTION_CHOICE_YES_NO = {
  YES: "yes",
  NO: "no",
} as const;

export const questionTypeOptions = [
  {
    value: QUESTION_TYPE.FREE_TEXT,
    label: "Free text response",
  },
  {
    value: QUESTION_TYPE.MULTIPLE_CHOICE,
    label: "Multiple choice",
  },
  {
    value: QUESTION_TYPE.YES_NO,
    label: "Yes/No",
  },
];

export const choicesModeOptions = [
  { label: "Single select", value: QUESTION_CHOICE_SELECTION_METHOD.SINGLE },
  {
    label: "Multiple select",
    value: QUESTION_CHOICE_SELECTION_METHOD.MULTIPLE,
  },
];

export const questionTypeToFieldsMap = {
  [QUESTION_TYPE.FREE_TEXT]: FreeTextQuestionFields,
  [QUESTION_TYPE.MULTIPLE_CHOICE]: MultipleChoiceQuestionFields,
  [QUESTION_TYPE.YES_NO]: YesNoQuestionFields,
};
